import { JobCardSkeleton, SkeletonBar } from "./JobCardSkeleton";

/**
 * The careers board while the fetch is in flight, in the dcv2 design language.
 *
 * The two sections below reuse JobPostings' own shell classes — the hero, the
 * filter rail, the 1240 container — so the page does not jump when the real
 * content replaces this, at any width. It renders inside <DcPage>, so it supplies
 * sections only and never its own ground.
 */
export function JobPostingsSkeleton() {
  return (
    <>
      {/* The page's own layout classes (global.css, T101026001), so the
          skeleton stacks on a phone exactly as the page it stands in for
          does, filters hidden (T101026002). */}
      <section className="jobs-hero" style={{ position: "relative", overflow: "clip" }}>
        <div style={{ maxWidth: 1240, margin: "0 auto" }}>
          <SkeletonBar width={190} height={13} />
          <div style={{ height: 22 }} />
          <SkeletonBar width="min(620px, 100%)" height={52} radius={12} delay={0.05} />
          <div style={{ height: 18 }} />
          <SkeletonBar width="min(520px, 100%)" height={16} delay={0.1} />
          <div style={{ height: 30 }} />
          <SkeletonBar width="min(660px, 100%)" height={52} radius={999} delay={0.15} />
        </div>
      </section>

      <section className="jobs-list-section" style={{ position: "relative", overflow: "clip" }}>
        <div className="jobs-layout">
          <aside
            className="jobs-skeleton-filters"
            style={{
              background: "var(--paper2)",
              border: "1px solid rgba(var(--ink-rgb),.13)",
              borderRadius: 18,
              padding: 28,
            }}
          >
            <SkeletonBar width={72} height={12} />
            <div style={{ height: 26 }} />
            {[0, 1, 2].map((group) => (
              <div key={group} style={{ marginBottom: group === 2 ? 0 : 26 }}>
                <SkeletonBar width={96} height={11} delay={0.05 * group} />
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 12 }}>
                  <SkeletonBar width={78} height={28} radius={999} delay={0.05 * group} />
                  <SkeletonBar width={66} height={28} radius={999} delay={0.05 * group + 0.05} />
                  <SkeletonBar width={88} height={28} radius={999} delay={0.05 * group + 0.1} />
                </div>
              </div>
            ))}
          </aside>

          <div style={{ minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 16,
                paddingBottom: 20,
                borderBottom: "1px solid rgba(var(--ink-rgb),.2)",
                marginBottom: 24,
              }}
            >
              <SkeletonBar width={110} height={13} />
              <SkeletonBar width={150} height={34} radius={999} delay={0.05} />
            </div>
            <div style={{ display: "grid", gap: 14 }}>
              {Array.from({ length: 5 }).map((_, i) => (
                <JobCardSkeleton key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
